export default __webpack_public_path__ + "static/media/190629_190332_IMG_9465.65a82252.jpg";